// Тексты обучения. Один файл на язык — чтобы править формулировки и переводить,
// не трогая код шагов (onboardingSteps.js ссылается сюда по ключам).
//
// Правила для текстов:
//   — коротко и простым языком, без банковских терминов;
//   — не обещаем одобрение и не называем ставки: условия определяет банк;
//   — заголовок до 40 знаков, текст — одно-два предложения.

const ru = {
  ui: {
    next: 'Далее',
    back: 'Назад',
    skip: 'Пропустить',
    finish: 'Готово',
    close: 'Закрыть обучение',
    stepOf: (current, total) => `${current} из ${total}`,
    restart: 'Пройти обучение заново',
    whereToFind: 'Обучение можно пройти в любой момент — кнопка «Пройти обучение заново» внизу меню.',
  },

  steps: {
    welcome: {
      title: 'Добро пожаловать',
      text: 'Это рабочее место кредитного брокера. Здесь вы заводите клиента, собираете сделку и одной анкетой отправляете заявку сразу в несколько банков.',
    },
    sidebar: {
      title: 'Разделы',
      text: 'Слева — все разделы: клиенты, лиды, продажи, автомобили и отчёты. Набор пунктов зависит от ваших прав.',
    },
    clients: {
      title: 'Клиенты',
      text: 'Открыли картотеку клиентов салона. С неё начинается любая сделка: сначала находим клиента, а если его нет — заводим.',
    },
    addClient: {
      title: 'Новый клиент',
      text: 'Кнопка заводит карточку клиента. Данные подтягиваются по ИИН, останется проверить и дополнить.',
    },
    search: {
      title: 'Быстрый поиск',
      text: 'Поиск работает по имени, телефону и ИИН. Так же он устроен в любом другом списке.',
    },
    filters: {
      title: 'Отбор по условиям',
      text: 'Расширенный поиск отбирает записи по статусу, дате, менеджеру и другим полям. Выбранные условия видно строкой под кнопкой.',
    },
    leads: {
      title: 'Лиды',
      text: 'Это раздел лидов — сюда падают обращения из мобильного приложения и с Halyk Market. Лид нужно взять в работу и довести до сделки, а если сделка по нему уже создана — отработать её до конца.',
    },
    deals: {
      title: 'Продажи',
      text: 'Это ваши сделки по новым и БУ автомобилям. Сюда же попадают сделки с Halyk Market — клиент оставил заявку на площадке и банк её одобрил. Внутри сделки собираются автомобиль, допы и документы клиента.',
    },
    cars: {
      title: 'Автомобили',
      text: 'Весь автопарк салона: наличие, комплектации, цены и VIN. Поиск по полному VIN находит машину в любом городе, даже если она стоит в другом.',
    },
    createDeal: {
      title: 'Как создать сделку',
      text: 'Сделка начинается отсюда, кнопкой «Продать авто»: выбираете клиента и машину, добавляете к ней допы и аксессуары, собираете документы и отправляете заявку в банки.',
    },
    addCar: {
      title: 'Новый автомобиль',
      text: 'Машины приезжают из стока сами, но любую можно завести руками — этой кнопкой. Понадобится, когда машины в стоке ещё нет, а сделку оформлять уже пора.',
    },
    credit: {
      title: 'Заявка в банки',
      text: 'Анкета заполняется один раз и уходит в несколько банков сразу. Суммы и платёж в сделке — наш расчёт: прежде чем называть их клиенту, сверьтесь с калькулятором банка. Итоговые условия определяет банк.',
    },
    decisions: {
      title: 'Решения банков',
      text: 'Ответы приходят во вкладку «Кредит» по мере готовности. Там же видно, какой банк что предложил и чего ещё ждём.',
    },
    profile: {
      title: 'Ваш профиль',
      text: 'Здесь видно ваш автосалон, роль и регион — проверьте, что всё верно. Если данные не те, напишите в техподдержку: от них зависит, какие машины и сделки вы видите.',
    },
    help: {
      title: 'Если что-то не работает',
      text: 'Кнопка «Проверить соединение» внизу меню скажет, видит ли программа сервер. Если связь есть, а что-то не работает — напишите в техподдержку.',
    },
  },

  checklist: {
    title: 'Первые шаги',
    subtitle: 'Пройдите путь до первой заявки',
    hide: 'Скрыть',
    done: 'Готово! Список больше не показываем.',
    items: {
      profile: 'Заглянуть в профиль',
      client: 'Завести клиента',
      deal: 'Создать сделку',
      application: 'Отправить заявку в банки',
      decisions: 'Посмотреть решения банков',
    },
  },

  hotspots: {
    addClient: 'Отсюда заводят нового клиента',
    filters: 'Здесь отбирают записи по условиям',
    credit: 'Здесь отправляют заявку в банки',
  },
};

export default ru;
